<template>
  <div>
    <div v-wechat-title="'最强蜗牛-爷（蜗）爷，你关注的神域终于更新啦！'"></div>
    <div class="pc-page">
      <div class="logo"></div>
      <div class="main"></div>
    </div>
  </div>

</template>
<script>
import { getTimeStamp } from '@/utils/utils';
import { mapActions } from 'vuex';
export default {
  components: {},
  data () {
    return {
      enterLink: '',
    };
  },
  created () {},
  mounted () {
    this.$nextTick(() => {
      // 分享
      const { protocol, host } = window.location;
      this.enterLink = `${protocol}//${host}/snail/hlw/enter${getTimeStamp()}`;
      this.monitoringEquipment();
      this.isSetShare(this.enterLink);
    });
  },
  computed: {},
  methods: {
    monitoringEquipment() {
      if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
        location.href = this.enterLink;
      }
    },
    // 微信分享
    isSetShare(linkUrl) {
      this.setShare({
        link: linkUrl + `${getTimeStamp()}`,
        title: '爷（蜗）爷，你关注的神域终于更新啦！',
        imgUrl: 'https://download4.qcplay.com/qcgame-api/Hmpg68XTBbVFL9n0HyLdNp48EdiWf8mCBSx2naIz.png',
        desc: '快来跟蜗一起，揭开神域的层层真相！',
      })
    },
    ...mapActions(["setShare"])
  }
};
</script>

<style lang="less">
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/hlw/pc/index.vue